<div class="menu">
  <div class="head-bred" id="bred" inlineSVG="assets/images/bento/bred.svg" [replaceContents]="false" [prepend]="true">
    <div class="head-bred_select" id="showSelect">
      <div *ngFor="let item of elements" class="head-bred_select__item" (mousedown)="handleYaCounterClick($event, item.event, item.link)">
        <div class="zoom-block">
          <img [src]="'assets/images/bento/' + item.img" [alt]="item.alt">
          <p>{{item.text | translate}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
